import React from 'react'
import { Steps, Button, message } from 'antd'
import injectSheet from 'react-jss'
import moment from 'moment';
import WrappedRegistrationForm from '../components/DiscountsGeneralForm'
import DiscountsConditionForm from '../components/DiscountsConditionForm'
import DiscountsDiscountForm from '../components/DiscountsDiscountForm'
import API from '../../../services/API'

const styles = {
    stepsContent: {
        margin: 16,
    },
}

const { Step } = Steps

// eslint-disable-next-line no-unused-vars
const steps = [
    {
        title: 'First',
        content: <WrappedRegistrationForm />,
    },
    {
        title: 'Second',
        content: 'Second-content',
    },
    {
        title: 'Last',
        content: 'Last-content',
    },
]

const INITIAL_STATE = {
    name: {
        value: '',
    },
    description: {
        value: '',
    },
    priority: {
        value: 1,
    },
    type: {
        value: 'quantity_based',
    },
    apply_to: {
        value: null,
    },
    items_to_apply: {
        value: [],
    },
}

class DiscountsCreateContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 0,
            data: INITIAL_STATE,
            simplePercentage: undefined,
            customDiscounts: [],
            // eslint-disable-next-line react/no-unused-state
            isLoading: false,
        }
    }

    next = () => {
        if (this.state.current === 2) {
            this.toSave();
            return
        }
        // eslint-disable-next-line react/no-access-state-in-setstate
        const current = this.state.current + 1
        this.setState({ current })
    }

    prev = () => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const current = this.state.current - 1
        this.setState({ current })
    }

    onFieldChange = (changedFields) => {
        this.setState(({ data }) => ({
            data: {
                ...data,
                ...changedFields,
            },
        }))
    }

    toSave = async () => {
        const { data, simplePercentage, customDiscounts } = this.state;
        this.setState({
            // eslint-disable-next-line react/no-unused-state
            isLoading: true,
        });
        // eslint-disable-next-line prefer-const
        let toSend = {
            priority: data.priority.value,
            name: data.name.value,
            description: data.description.value,
            type: data.type.value,
            active: data && data.active && data.active.value !== undefined ? data.active.value : true,
            // date_from: null,
            // date_to: null,

            // product, category, brand
            // apply_to: data.apply_to.value,
            // items_to_apply: this.props.items_to_apply,

            // discount_range: this.props.discount_range,
            // item_based_condition: this.props.item_based_condition,
            // item_based_discount: this.props.item_based_discount,
            // items_to_exclude: this.props.items_to_exclude,

            // buy_type: data.buy_type.value,
            // items_to_apply_count_option: data.items_to_apply_count_option.value,
            // items_to_apply_count: data.items_to_apply_count.value,
            // quantity_rule: data.quantity_rule.value,
            // quantity_from: data.quantity_from.value,
        }

        if (data && data.date_from && data.date_from.value) {
            toSend.date_from = moment(data.date_from.value).format('YYYY-MM-DD');
        }
        if (data && data.date_to && data.date_to.value) {
            toSend.date_to = moment(data.date_to.value).format('YYYY-MM-DD');
        }
        let item_based_condition = null;
        let item_based_discount = null;
        // El type va a decirdir que traza tomar para crear el objeto
        if (data.type.value === 'item_based') {
            item_based_condition = {}
            if (data && data.items_to_buy && data.items_to_buy.value) {
                // toSend.items_to_buy = data.items_to_buy.value.map((g) => +g.key);
                item_based_condition.items_to_buy = data.items_to_buy.value.map((g) => +g.key);
            }
            if (data && data.apply_when_buy && data.apply_when_buy.value) {
                // apply_when_buy
                // toSend.apply_when_buy = data.apply_when_buy.value;
                item_based_condition.apply_when_buy = data.apply_when_buy.value;
            }
            if (data && data.buy_type && data.buy_type.value) {
                // Puede ser any, each, combine
                // toSend.buy_type = data.buy_type.value;
                item_based_condition.buy_type = data.buy_type.value;
            }
            if (data && data.items_to_apply_count_option && data.items_to_apply_count_option.value) {
                // All, apply_first, skip_first (items_to_apply_count_option)
                // items_to_apply_count_option
                // toSend.items_to_apply_count_option = data.items_to_apply_count_option.value;
                item_based_condition.items_to_apply_count_option = data.items_to_apply_count_option.value;
            }
            if (data && data.items_to_apply_count && data.items_to_apply_count.value) {
                // cantidad de arriba
                // items_to_apply_count
                // toSend.items_to_apply_count = +data.items_to_apply_count.value;
                item_based_condition.items_to_apply_count = +data.items_to_apply_count.value;
            }
            // quantity_rule
            if (data && data.quantity_rule && data.quantity_rule.value) {
                // quantity_rule
                // toSend.quantity_rule = data.quantity_rule.value;
                item_based_condition.quantity_rule = data.quantity_rule.value;
            }
            if (data && data.quantity_from && data.quantity_from.value) {
                // cantidad de arriba
                // quantity_from, falta el quantity_to Habilitado si quantity_rule = from
                // toSend.quantity_from = +data.quantity_from.value;
                item_based_condition.quantity_from = +data.quantity_from.value;
            }
            if (data && data.quantity_to && data.quantity_to.value) {
                // cantidad de arriba
                // quantity_from, falta el quantity_to Habilitado si quantity_rule = from
                item_based_condition.quantity_to = +data.quantity_to.value;
            }
            if (data && data.apply_to && data.apply_to.value) {
                item_based_condition.apply_to = data.apply_to.value;
            }
            if (data && data.items_to_apply && data.items_to_apply.value) {
                item_based_condition.items_to_apply = data.items_to_apply.value.map((g) => +g.key);
            }
            if (data && data.discount_type && data.discount_type.value) {
                item_based_discount = { discount_type: '', discount_value: 0 }
                // discount_type
                // toSend.discount_type = data.discount_type.value;
                item_based_discount.discount_type = data.discount_type.value;
            }
            if (data && data.discount_value && data.discount_value.value) {
                // discount_value
                // toSend.discount_value = data.discount_value.value;
                item_based_discount.discount_value = data.discount_value.value;
            }
        }
        if (data.type.value === 'quantity_based') {
            if (data && data.apply_to && data.apply_to.value) {
                toSend.apply_to = data.apply_to.value;
            }
            toSend.items_to_apply = (data && data.items_to_apply && data.items_to_apply.value)
                ? data.items_to_apply.value.map((g) => +g.key)
                : [];

            toSend.default_discount = {
                discount_type: 'percentage',
                value: +simplePercentage,
            };

            toSend.custom_discounts = (customDiscounts || [])
                .filter((custom) => custom.selectedProducts && custom.selectedProducts.length > 0 && custom.discountKind)
                .map((custom) => {
                    if (custom.discountKind === 'percentage') {
                        return {
                            selected_products: custom.selectedProducts.map((p) => +p.id),
                            discount_kind: 'percentage',
                            percentage_value: +custom.percentageValue,
                        };
                    }
                    return {
                        selected_products: custom.selectedProducts.map((p) => +p.id),
                        discount_kind: 'range',
                        range_min: +custom.rangeMin,
                        range_max: +custom.rangeMax,
                        range_discount_type: custom.rangeDiscountType,
                        range_value: +custom.rangeValue,
                    };
                });
        }

        let discount_subsidiaries = [];
        if (data && data.subsidiarie_id && data.subsidiarie_id.value) {
            discount_subsidiaries = data.subsidiarie_id.value.map((g) => +g);
        }
        let discount_customer_type = [];
        if (data && data.customer_type_id && data.customer_type_id.value) {
            discount_customer_type = data.customer_type_id.value.map((g) => +g);
        }

        toSend = {
            ...toSend,
            item_based_discount,
            item_based_condition,
            discount_customer_type,
            discount_subsidiaries,
        }

        // eslint-disable-next-line no-unused-vars, prefer-const
        let response = null;
        try {
            response = await API.post('/api/discounts', toSend);
        } catch (error) {
            let errorMessage = "Error al guardar!";
            if (error.response && error.response.data) {
                console.log('error response',error.response);
                errorMessage +=", "+error.response.data.message;
              }
            message.error(errorMessage)
        }
        this.setState({
            // eslint-disable-next-line react/no-unused-state
            isLoading: false,
        });
        if (response.status === 201) {
            // se guardo con exito
            message.success('Se guardo con exito!')
            setTimeout(() => {
                this.props.history.push('/discounts')
            }, 300);
        }
    }

    render() {
        const { classes } = this.props
        const { current, data } = this.state
        return (
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: 3,
                    padding: 16,
                }}
            >
                <Steps current={current}>
                    <Step title="General" />
                    <Step title="Condición" />
                    <Step title="Descuento" />
                </Steps>
                <div className={classes.stepsContent}>
                    {current === 0 && (
                        <WrappedRegistrationForm
                            {...data}
                            onFieldChange={this.onFieldChange}
                            onCompleted={() => this.next()}
                            isLoading={this.state.isLoading}
                            history={this.props.history}
                        />
                    )}

                    {current === 1 && (
                        <DiscountsConditionForm
                            {...data}
                            onFieldChange={this.onFieldChange}
                            onCompleted={() => this.next()}
                            isLoading={this.state.isLoading}
                        />
                    )}

                    {current === 2 && (
                        <DiscountsDiscountForm
                            {...data}
                            isLoading={this.state.isLoading}
                            simplePercentage={this.state.simplePercentage}
                            customDiscounts={this.state.customDiscounts}
                            onDiscountsChange={(changes) => this.setState(changes)}
                            onFieldChange={(changedFields) => {
                                if (this.onFieldChange) {
                                    this.onFieldChange(changedFields);
                                }
                            }}
                            onCompleted={() => this.next()}
                            // onFieldChange={this.onFieldChange}
                            // eslint-disable-next-line react/jsx-closing-bracket-location
                        />
                    )}
                </div>
                <div className="steps-action">
                    {/* {current < steps.length - 1 && (
						<Button type="primary" onClick={() => this.next()}>
							Next
						</Button>
					)} */}
                    {/* {current === steps.length - 1 && (
                        <Button type="primary" onClick={() => message.success('Processing complete!')}>
                            Done
                        </Button>
                    )} */}
                    {current > 0 && (
                        <Button
                            style={{ marginLeft: 8 }}
                            onClick={() => this.prev()}
                            disabled={this.state.isLoading}
                            loading={this.state.isLoading}
                        >
                            Regresar
                        </Button>
                    )}
                </div>
            </div>
        )
    }
}

export default injectSheet(styles)(DiscountsCreateContainer)
